import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IListSkillFetchParams,
  ISkill,
  MN_SKILLS,
} from '@jobcost-monorepo/crud';

export default function SkillsPage() {
  return (
    <Grid<ISkill, IListSkillFetchParams>
      moduleName={MN_SKILLS}
      updateStore={false}
    ></Grid>
  );
}
